/*
  src/components/About.jsx
  ─────────────────────────────────────────────────────────────────
  CHANGE FROM PREVIOUS VERSION:
    Quick Info Strip updated to remove duplication with the
    Important Dates section below it.

    REMOVED from strip : Ceremony Date, Rehearsal
      (these already appear in ImportantDates section)

    REPLACED with     : Dress Code, Guest Seats
      (unique info not shown anywhere else on the page)

  QUICK INFO STRIP NOW SHOWS:
    • Venue        — where the ceremony is held
    • Dress Code   — formal attire reminder
    • Guest Seats  — max 2 per graduate
    • Registration — current status (highlighted)
*/
import React from 'react';
import './About.css';
import hariMenonImage from '../assets/Hari Menon.png';

const quickInfo = [
  {
    icon: '🏛️',
    label: 'Venue',
    value: 'BITS Pilani, Hyderabad Campus',
    highlight: false,
  },
  {
    icon: '👔',
    label: 'Dress Code',
    value: 'Formal Attire Required',
    highlight: false,
  },
  {
    icon: '✅',
    label: 'Registration',
    value: 'Closed',
    highlight: true,
  },
];

const About = () => (
  <section id="about" className="section about-section">
    <div className="container">

      {/* ── Section header ──────────────────────────────────────── */}
      <div className="section-header reveal">
        <h2 className="section-title">About the Ceremony</h2>
        <div className="divider" />
        <p className="section-subtitle">A milestone worth celebrating</p>
      </div>

      {/* ── About text ──────────────────────────────────────────── */}
      <div className="about__text reveal">
        <p>
          The convocation ceremony for the graduating students who have completed the eligibility requirements in the academic year <strong>2025–26</strong> of First Degree, Higher Degree, and Ph.D. Programmes from{' '}
          <strong>BITS Pilani, Hyderabad Campus</strong> is scheduled on a date to
          be announced shortly.
        </p>
        <p>
          To attend the convocation ceremony, the student must attend the rehearsal
          without exception. Participants are requested to plan their travel
          accordingly and check the website for further updates.
        </p>
      </div>

     {/* ── Chief Guest ────────────────────────────────────────── */}
      <div className="chief-guest reveal">
        <div className="chief-guest__image-wrap">
          <a
            href="https://www.linkedin.com/posts/bits-pilani-hyderabad-campus_bitshyderabad-convocation2026-bphcgrad26-activity-7480116819824001024-sPUM?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAP_R24B-6PP-Ip9OkQAlytaByX4FtQHv64"
            target="_blank"
            rel="noreferrer"
          >
            <img src={hariMenonImage} alt="Mr. Hari Menon" className="chief-guest__image" />
          </a>
        </div>
        <div className="chief-guest__content">
          <h3 className="chief-guest__title">Chief Guest</h3>
          <p className="chief-guest__intro">
             We are delighted to welcome{' '}
            <a href="https://www.linkedin.com/in/harimenon-bigbasket/" target="_blank" rel="noreferrer">
              Mr. Hari Menon
            </a>, Co-Founder of{' '}
            <a href="https://www.linkedin.com/company/bigbasket-com/" target="_blank" rel="noreferrer">
              bigbasket
            </a>{' '}
            and a distinguished alumnus of BITS Pilani, as the Chief Guest for the Convocation 2026 at{' '}
            <a href="https://www.linkedin.com/company/bits-pilani-hyderabad-campus/" target="_blank" rel="noreferrer">
              BITS Pilani, Hyderabad Campus
            </a>.
          </p>
          <p>
            An inspiring entrepreneur and visionary leader, Mr. Menon has played a pivotal role in transforming India's online grocery landscape through innovation, resilience, and an unwavering focus on customer excellence.
          </p>
          <p>
            His remarkable journey from a BITS Pilani alumnus to one of India's most respected entrepreneurs serves as an inspiration to aspiring innovators and future leaders.
          </p>
          <p>
            We are honoured to host him on our campus and look forward to his address to the graduating Class of 2026 as they celebrate their achievements and embark on the next chapter of their journeys.
          </p>
           </div>
      </div>

       {/* ── Quick Info Strip ────────────────────────────────────── */}
      <div className="quick-info reveal">
        {quickInfo.map((item, i) => (
          <div
            key={i}
            className={`quick-info__card ${item.highlight ? 'quick-info__card--highlight' : ''}`}
          >
            <span className="quick-info__icon">{item.icon}</span>
            <div className="quick-info__text">
              <span className="quick-info__label">{item.label}</span>
              <span className="quick-info__value">{item.value}</span>
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default About;
